import React from 'react'

import styles from './switchInput.module.css'

function SwitchInput(props) {

    return (
        <label>
            <input
                type={"checkbox"}
                className={`${styles.switch} ${props.checked === '1' ? styles.checked : ''}`}
                checked={props.checked !== "0"}
                onChange={() => props.setChecked(props.checked === '0' ? '1' : '0')}
                onKeyDown={(event) => {
                    if (event.key === "Enter") {
                        props.setChecked(props.checked === '0' ? '1' : '0')
                    }
                }}
            />
            <span className={styles.text}>{props.text}</span>
        </label>
    )
}

export default SwitchInput